export default {
    newDesign: true,
    parameters: {
      landing_id: "TrQFwdB",
      segment: 11,
    },
    downtimeUrl: "https://www.kodland.org/tr",
    title: "Dijital Tasarım Dersini Ücretsiz Dene! | Kodland",
    startPage: {
      title:
        "Özel bir teklifin kilidini açtınız — 1 saatlik Dijital Tasarım dersi, normalde <del>850 TL</del>, indirimli fiyatı <del>40 TL</del>, bugün ise TAMAMEN ÜCRETSİZ!",
      subtitle: "Hemen başlamak için 5 soruyu cevaplayın.",
      button: "🚀 Şimdi teste başlayın",
      image: {
        url: "/welcome/tr_fwd_offer_bright_desk.png",
        style: {
          height: "100%",
          "max-height": "100vh",
        },
      },
      imageMobile: {
        url: "/welcome/tr_fwd_offer_bright_mob.png",
        style: {
          width: "100%",
        },
      },
    },
    stopPage: {
      image: "/welcome/quizV2/no-computer.png",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
      subtitle:
        "Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question: "Çocuğunuz genellikle günde ne kadar süre cihaz başında vakit geçiriyor?",
        answers: [
          "🥰 1 saat",
          "🙂 2-3 saat",
          "😔 4 saatten fazla"
        ],
      },
      2: {
        question: "Çocuğunuzun kişiliğini nasıl tanımlarsınız?",
        subtitle: "Bu cevap, bize doğru öğretim metodolojisini seçmemize yardımcı olacaktır.",
        answers: [
            "🥳 Aktif, çok iletişimde olan",
            "😌 Utangaç",
            "🤩 Vizyoner",
            "🤫 Sakin, yalnız kalmayı tercih eder",
            "🤔 Ne istediğini pek bilmiyor",
            "❓Önerim (derslerde açıklayacağım)"
        ],
      },
      3: {
        question: "Çocuğunuzun öğrenmeye olan motivasyonu ne kadar yüksek?",
        answers: [
          "🚀 Yüksek",
          "😕 Düşük",
          "🙂 Normal"
        ],
      },
      4: {
        title: "Çocuğunuzun yaşı kaç?",
        type: "age",
        subtitle:
          "Çocuğunuzun yaşına en uygun kursu seçeceğiz.",
        button: "",
      },
      5: {
        question:
          "Çocuğunuzun eğitim için bilgisayar veya laptopu var mı?",
        answers: [
          "👍 Evet",
          {
            answer: "👎 Hayır",
            stopAnswer: true,
          },
        ],
      },
      6: {
        title: "Tebrikler 🎉",
        typeInfo: "congrats",
        subtitle:
          "Bir adım kaldı. Çocuğunuzun animasyon, illüstrasyon ve tasarım alanlarındaki yaratıcı potansiyelini keşfedin!",
        button: "📅 Bir ders planlayın",
      },
      7: {
        title: "Ücretsiz derse kaydolun",
        type: "one-page-contacts",
        subtitle: "Birbirimizi tanıyalım, ne öğreneceğimizi ve derslerin nasıl yapılacağını öğrenelim.",
        button: "Neredeyse bitti 🔥",
      },
      8: {
        title: "",
        type: "timeslot",
        subtitle: "",
        button: "",
      },
      9: {
        title:
          "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
        typeInfo: "pc-laptop",
        subtitle:
          "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
        button: "Başka neler var?",
      },
      10: {
        title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
        typeInfo: "whatsapp",
        subtitle:
          "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
        button: "Başka neler var?",
      },
      11: {
        title: "Ders platformumuzda gerçekleşecek 💻",
        typeInfo: "classroom",
        subtitle:
          "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
        button: "Anladım ✅",
      }
    },
  };